import React from "react";
import { motion } from "framer-motion";
import { QuoteIcon } from "lucide-react";
import { IMAGES } from "../src/config";
export function AuthorSection() {
  return <section className="w-full bg-[#0d0b22] py-16" data-id="element-28" data-mp="178gg23pu88iq">
      <div className="mx-auto grid max-w-5xl items-center gap-8 px-4 sm:px-6 md:grid-cols-[280px_1fr]" data-id="element-29" data-mp="1775f0bns1evb">
        <motion.img initial={{
        opacity: 0,
        scale: 0.94
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} src={IMAGES.author} alt="Lloyd, fundador de Nexto Digital" className="mx-auto w-56 rounded-2xl border border-white/10 object-cover shadow-xl md:w-full" data-id="element-30" data-mp="129wtc13f6spb" />
        <div data-id="element-31" data-mp="jhuhd31q40le">
          <QuoteIcon className="h-8 w-8 text-violet-500" data-id="element-32" data-mp="jhb2xwba7uc4" />
          <p className="mt-3 text-lg leading-relaxed text-slate-200" data-id="element-33" data-mp="3ry5ska32ji89">
            Yo mismo empecé peleando por proyectos de $50 en el mercado hispano.
            Cuando entendí cómo usar la IA para <span className="font-semibold text-white" data-id="element-34" data-mp="2vo3neaj15458">
            sonar como un nativo</span>, todo cambió. Hoy en Nexto Digital
            facturamos en dólares y quiero darte el mapa exacto para que hagas lo
            mismo.
          </p>
          <p className="mt-4 font-display font-bold text-white" data-id="element-35" data-mp="34hgssbya5y87">Lloyd</p>
          <p className="text-sm text-slate-400" data-id="element-36" data-mp="39fi76jkrh9dc">Fundador · Nexto Digital</p>
        </div>
      </div>
    </section>;
}